import React, { useState } from "react";
import { Box, CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleDrawerToggle = () => {
    isMobile ? setMobileOpen(!mobileOpen) : setIsCollapsed(!isCollapsed);
  };

  const drawerWidth = isCollapsed ? 80 : 250;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header handleDrawerToggle={handleDrawerToggle} />
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isCollapsed={isCollapsed}
        drawerWidth={drawerWidth}
      />
      <Box
        component="main"
        className="can-scroll"
        sx={{
          flexGrow: 1,
          // p: { xs: 2, sm: 3 },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          transition: "width 0.3s, padding 0.3s",
          mt: { xs: "56px !important", sm: "64px !important" },
          bgcolor: "#f8f9fa",
          minHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
          height: { xs: "auto", sm: "calc(100vh - 64px)" },
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default Layout;
